(function ($) {
  // cookies
  $.each($("#modal-cookies .collapse"), function (index, el) {
    $(el).on("hidden.bs.collapse", function (ev) {
      $(ev.target).prev("legend").removeClass("border-bottom");
    });
    $(el).on("shown.bs.collapse", function (ev) {
      $(ev.target).prev("legend").addClass("border-bottom");
    });
  });

  $("#modal-cookies legend input").on("change", function (e) {
    $(e.target).closest("fieldset").find("input[type=checkbox]").prop("checked", e.target.checked);
  });

  $(".collapse input[type=checkbox]").on("change", function (e) {
    var inputs = $(e.target).closest(".collapse").find("input[type=checkbox]");
    var res = {
      ok: 0,
      error: 0,
    };
    $.each(inputs, function (index, el) {
      el.checked ? res.ok++ : res.error++;
    });
    if (res.ok == inputs.length) {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", true);
    } else {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", false);
    }
  });

  $("#modal-cookies .btn-select-all").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]").prop("checked", true);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies .btn-just-essential").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]:not([disabled])").prop("checked", false);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies form").on("submit", function (e) {
    var valid = [
        "cookiePolicy",
        "matomo",
        // "adform",
        "google",
        // "facebook"
    ];
    var cookieData = {};
    var $form = $(e.target);
    var data = $form.serializeArray();

    $.each(valid, function (i, e) {
      var enable = data.findIndex(function (obj) {
        return obj.name === e;
      }) + 1 > 0;
      cookieData[e] = enable;
    });

    if (!cookieData.cookiePolicy) {
        cookieData.cookiePolicy = true;
    }

    $.each(cookieData, function (key, enabled) {
      switch (key) {
        case "cookiePolicy":
          break;

        case "matomo":
          if (typeof _paq !== "undefined") {
            if (enabled) {
                _paq.push(['rememberCookieConsentGiven']);
                _paq.push(['trackPageView']);
            } else {
                _paq.push(['forgetCookieConsentGiven']);
            }
          }
          break;

        case "google":
          if (enabled) {
            if (typeof gtag === "undefined") {
                initGtag();
                initGMaps();
              }
          }
          break;

        case "facebook":
            if (enabled) {
              if (typeof fbq === "undefined") {
                initFBpx();
              }
          }
          break;
      }
    });
    BPM.COOKIESETTING = cookieData;
    createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    $("#modal-cookies").modal("hide");
    return false;
  });

  var checkCookie = function (name) {
    var nameCheck = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameCheck) == 0) return c.substring(nameCheck.length, c.length);
    }
    return null;
  };

  var createCookie = function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Strict"
        + (location.protocol.indexOf('https') !== -1 ? '; Secure=true' : '');
  };

  var eraseCookie = function (name) {
    createCookie(name, "", -1);
  };

  var initGtag = function () {
    if (!GTAG_ID || GTAG_ID === 'XX-XXXXXX') {
      console.log('GTAG_ID: ' + GTAG_ID);
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GTAG_ID);
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + GTAG_ID;
      document.head.append(s);
    })();
  };

  var initGMaps = function() {
    if (!$('.section-map').length) return;
    loadYtPreviews();
    $('.section-map').each(function(index, el) {
      $(el).find('.alert-container')
        .prop('hidden', true);
      $(el).find('.ratio')
        .prop('hidden', false)
        .find('iframe')
        .attr('src', $(el).find('iframe').attr('data-src'));
    });
  };

  var initFBpx = function() {
    if (!FB_PX || FB_PX === 'XX-XXXXXX') {
      console.log('FB_PX: ' + FB_PX);
      return false;
    }
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', FB_PX);
    fbq('track', 'PageView');
  };

  BPM.COOKIESETTING = JSON.parse(decodeURIComponent(checkCookie(BPM.CookiePolicy.cookieName))) || {
    cookiePolicy: false,
    matomo: false,
    google: false,
    facebook: false,
  };

  BPM.CookiePolicy.cookieDuration = 30; // Tag/e

  $(function () {
    // console.log(BPM.COOKIESETTING)
    if (!BPM.DNT && BPM.COOKIESETTING.cookiePolicy === false
        && window.location.href.indexOf('/impressum') + 1 < 1
        && window.location.href.indexOf('/datenschutzerklaerung') + 1 < 1
    ) {
        jQuery("#modal-cookies").modal("show");
    }
    // if (BPM.COOKIESETTING.cookiePolicy === true) {
    //     $("#customCookieModal").prop("checked", true);
    //     $("#cookieSet1").prop("checked", true);
    // }
    if (BPM.COOKIESETTING.matomo === true) {
      $("#customMatomo").prop("checked", true);
      $("#cookieSet3").prop("checked", true);
    }
    // if (BPM.COOKIESETTING.facebook === true) {
    //   // $("#cookieSet2").prop("checked", true);
    //   $("#customFacebook").prop("checked", true);
    //   initFBpx();
    // }
    // if (BPM.COOKIESETTING.google === true) {
    //   $("#customGoogle").prop("checked", true);
    //   initGtag();
    //   initGMaps();

    //   // if (/* BPM.COOKIESETTING.adform && */BPM.COOKIESETTING.facebook === true) {
    //     $("#cookieSet2").prop("checked", true);
    //   // }
    // }
    if (!BPM.DNT) {
      createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    }
  });


    function loadYtPreviews() {
        $('.section-yt-video').each(function(index, el) {
            if ($(el).attr('data-preview') === "true") {
                $(el).find('img').attr(
                    'src',
                    $(el).find('img').attr('data-src')
                );
            }
        });
    }


  // autoplay yt videos
  $(".modal-yt-video").on("shown.bs.modal", function (e) {
    $("iframe", e.target).attr("src", $("iframe", e.target).attr("data-src") + "?autoplay=1");
  });
  $(".modal-yt-video").on("hidden.bs.modal", function (e) {
    $("iframe", e.target).attr("src", null);
  });


  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  $(".contact_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");
    var text = $(el).html().trim();

    var link = $("<a>", {
      href: "mailto:" + mail,
      rel: "nofollow",
      class: ($(el).attr('class') || "").replace('contact_me', ''),
    });
    link.html(!text ? mail : text);
    $(el).replaceWith(link);
  });


  $("html").removeClass("no-js").addClass("js");

  $(window).resize(
    debounce(function (e) {
      if ($('.bg-img').length) {
        window.setTimeout(function () {
          $('.bg-img').each(function(index, el) {
            resizeImage($(el));
          });
        }, 0);
      }
      if ($('.vert-img').length) {
        window.setTimeout(function () {
          $('.vert-img').each(function(index, el) {
            vertImage($(el));
          });
        }, 0);
      }
    }, 400)
  );


  function smoothScroll(e, direct) {
    var target;
    if (typeof direct === "undefined" || !direct) {
      target = this.hash || window.location.hash;
      target = !target ? $(e.target).closest("a").attr("href") : target;
    } else {
      target = e;
    }

    var $target = $(target).length ? $(target) : $("[name='" + window.location.hash.substr(1) + "']");

    // console.log($target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - $('.site-header').outerHeight(true),
        },
        400,
        "linear"
        // function() {
        //   window.location.hash = target;
        // }
      );
        if (!!window.history) {
            history.pushState({}, window.title, '#' + $target.attr('id'));
        }
    return false;
  }

    if (!!window.location.hash) {
        smoothScroll(window.location.hash, 1);
    }

    // $('.wp-block-bpm-block-btn', '.page-id-269').on('click', function(e) {
    //     e.preventDefault();
    //     return smoothScroll("#" + $(e.target).closest('a').attr('href').split("#").pop(), 1);
    // });


  // scrollto hash
  $(".scrollTo").on("click", function (e) {
    e.preventDefault();
    smoothScroll(e);
    return false;
  });

    $(window).on('scroll', function() {
        if ( $(window).scrollTop() > 200 ) {
            $('#scrollTop').removeClass('d-none');
        } else {
            $('#scrollTop').addClass('d-none');
        }
    });


  // // scrollto navlinks
  // $(".nav-link", "#main-primary-menu").on("click", function (e) {
  //   var href = $(e.target).closest("a").attr("href");
  //   if (href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
  //   smoothScroll("#" + href.split("#").pop(), 1);
  //   $(e.target)
  //     .closest("ul")
  //     .find("li.active")
  //     .removeClass("current-menu-item active current-menu-item current_page_item");
  //   $(e.target).closest("ul").find("a").removeClass("current-menu-item current_page_item");
  //   $(e.target)
  //     .closest("li")
  //     .addClass("current-menu-item active")
  //     .find("a")
  //     .addClass("current-menu-item current_page_item");
  //   return false;
  // });


  // // navlink active link onload
  // $(window).on("load", function (e) {
  //   if (window.location.pathname !== "/") return;
  //   $("#main-primary-menu")
  //     .find("li.active")
  //     .removeClass("current-menu-item active current-menu-item current_page_item");
  //   $("#main-primary-menu").find("a").removeClass("current-menu-item current_page_item");
  //   $("li:first-of-type", "#main-primary-menu")
  //     .addClass("current-menu-item active")
  //     .find("a")
  //     .addClass("current-menu-item current_page_item");
  //   return false;
  // });



  // carousel img repair & touch
  function resizeImage($img) {
    $img.removeClass("resizeVertical");
    console.log('resize', $img.attr('src'))
    if ($img.width() < $img.parent().width() && $img.width() > 0 && $img.height() >= $img.parent().height()) {
      $img.addClass("resizeVertical");
    }
  }
  function vertImage($img) {
    $img.removeClass("resizeVertical");
    console.log('vert', $img.attr('src'))
    if ($img.height() < $img.parent().height() && $img.width() >= $img.parent().width() && $img.width() > 0) {
      $img.addClass("resizeVertical");
    }
  }

  $('img').on('load', function(e) {
    window.setTimeout(function() {
        if ($(e.target).hasClass('bg-img')) {
          resizeImage($(e.target));
        }
        if ($(e.target).hasClass('vert-img')) {
          vertImage($(e.target));
        }
    }, 0);
  });


  $(".carousel").on("touchstart", function (event) {
    if ($(event.target).closest(".carousel").hasClass("view")) return false;
    var xClick = event.originalEvent.touches[0].pageX;
    $(this).one("touchmove", function (event) {
      var xMove = event.originalEvent.touches[0].pageX;
      var btCarousel = bootstrap.Carousel.getOrCreateInstance(this);
      if (Math.floor(xClick - xMove) > 5) {
        btCarousel.next;
      } else if (Math.floor(xClick - xMove) < -5) {
        btCarousel.prev;
      }
    });
    $(".carousel").on("touchend", function () {
      $(this).off("touchmove");
    });
  });


  if (!!navigator.userLanguage || !!navigator.browserLanguage || !!navigator.systemLanguage) {
    $("body").addClass("ie11");
    // console.log("ie11");
  }


  //
  var bpmShadowSvg = function (icon, classes) {
    return '<div class="svg-wrapper"><svg fill="currentColor"'
      + (!classes || classes.length ? '' : (' class="' + classes.join(' ') + '"'))
      + '><use href="#' + icon + '"/></svg></div>';
  };

  
  var $window = $(window);
  function reRenderMainNav() {
      var $oMainNav = $('#navbar-main').find('.container'),
          $oNavList = $('#bb4-primary-menu'),
          $oMoreLinks = $oNavList.find('.moreLinks');

      // Abbrechen, wenn Fensterbreite <= 767
      if ($window.width() <= 750) {
          $oMoreLinks.each(function () {
          $(this).addClass('nav-item')
              .find('.dropdown-item')
              .removeClass('dropdown-item')
              .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
          $oMoreLinks.remove();
          return;
      }

      if ($oMoreLinks.length) {
          $oMoreLinks.find('> ul > li').each(function () {
              $(this).addClass('nav-item')
                  .find('> .dropdown-item')
                  .removeClass('dropdown-item')
                  .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
      } else {
          var oMoreLinkElem = document.createElement('li'),
              oMoreLinkAElem = document.createElement('a'),
              oMoreLinkUlElem = document.createElement('ul');

          oMoreLinkElem.className = 'dropdown dropstart moreLinks menu-item nav-item';

          oMoreLinkAElem.className = 'dropdown-toggle nav-link menu-item d-inline-flex align-items-center';
          oMoreLinkAElem.innerHTML = '&nbsp;<div class="icon">' + bpmShadowSvg('svg-ellipsis-h') + '</div>&nbsp;'; // BPM.txt.more;
          oMoreLinkAElem.setAttribute('data-bs-toggle', 'dropdown');

          oMoreLinkUlElem.className = 'dropdown-menu';
          oMoreLinkUlElem.setAttribute('role', 'menu');

          oMoreLinkElem.appendChild(oMoreLinkAElem);
          oMoreLinkElem.appendChild(oMoreLinkUlElem);

          $oNavList.append(oMoreLinkElem);
          $oMoreLinks = $(oMoreLinkElem);
      }

      var iMainNavWidth = $oMainNav.width()
              - $oMainNav.find('.navbar-brand').outerWidth(true)
              - $oMainNav.find('.ms-auto.me-0').outerWidth(true),
          $oNavItems = $oNavList.find('> li').not('.moreLinks'),
          iNavItemsWidth = 0,
          aMoreLinkElems = [];

      $oNavItems.each(function () {
          var $this = $( this );
          iNavItemsWidth += $this.outerWidth(true);
      });

      if (iNavItemsWidth > iMainNavWidth) {
          iMainNavWidth -= Math.ceil($oMoreLinks.outerWidth(true));
          iNavItemsWidth = 0;
          
          $oNavItems.each( function ()
              {
                  var $this = $( this );
                  iNavItemsWidth += $this.outerWidth(true);
              
                  if (Math.ceil(iNavItemsWidth) > iMainNavWidth) {
                      $this.removeClass('nav-item')
                          .find('> .nav-link')
                          .addClass('dropdown-item')
                          .removeClass('nav-link');
                      if ($this.hasClass('active')) {
                          $this.find('> a').addClass('active');
                      }
                      aMoreLinkElems.push( $this );
                  }
              }
          );
      }

      if (aMoreLinkElems.length) {
          $oMoreLinks.find('> ul').append(aMoreLinkElems);
      } else {
          $oMoreLinks.remove();
      }
  }

    $(function () {
        reRenderMainNav();
        if (!animationHeader) {
            requestAnimationFrame(startAnimation);
        }
        stopAnimation();
    });

    $(window).resize(function() {
        reRenderMainNav();
        if (!animationHeader) {
            requestAnimationFrame(startAnimation);
        }
        stopAnimation();
    });

    var animationHeader = false;
    function startAnimation(timestamp) {
        // if (window.innerWidth < 768) return;
        $('.rotate-cw').animate({rotate: '+=.2deg'}, 0);
        $('.rotate-ccw').animate({rotate: '-=.2deg'}, 0);
        animationHeader = requestAnimationFrame(startAnimation)
    }

    function stopAnimation() {
        // if (window.innerWidth > 767) return;
        // cancelAnimationFrame(animationHeader);
        // animationHeader = false;
    }

    //////
    $('.single-gallery').magnificPopup({
        type: 'image',
        gallery:{
        enabled:true
        }
    });

    $('.gallery_enlarge_icon').magnificPopup({
        type: 'image',
        gallery:{
        enabled:true
        }
    });

    $('.widget .wp-block-gallery a').magnificPopup({
        type: 'image',
        gallery:{
        enabled:true
        }
    });

    if ($('.partner').length) {
        $('.partner').owlCarousel({
                margin: 30,
                autoPlay: 5000,
                items : 5,
                nav: false,
                loop: true,
                navText:[
            "<div class='icon-lg'><div class='svg-wrapper'><svg><use href='#svg-chevron-left'/></svg></div></div>",
            "<div class='icon-lg'><div class='svg-wrapper'><svg><use href='#svg-chevron-right'/></svg></div></div>"
          ],
                responsive:{
                    0:{
                        items:2,
                        
                    },
                    600:{
                        items:3,
                        
                    },
                    1000:{
                        items:5,
                    }
                }
            });
    }

    if ($('.sec-testimonials.owl-carousel').length) {
        $('.sec-testimonials.owl-carousel').owlCarousel({
                items : 3,
                autoplay: true,
                center: true,
                loop: true,
                navText:[
            "<div class='icon-lg'><div class='svg-wrapper'><svg><use href='#svg-chevron-left'/></svg></div></div>",
            "<div class='icon-lg'><div class='svg-wrapper'><svg><use href='#svg-chevron-right'/></svg></div></div>"
          ],
                nav: true,
                dots: false,
                margin: 30,
                responsive:{
                    0:{
                        items:1,
                        
                    },
                    768:{
                        items:1,
                        
                    },
                    1000:{
                        items:3,
                
                    }
                }
            });
      }


    //// admin bar fix
    if ($('#wpadminbar').length) {
        $('html').attr('style', function(i,s) { return (s || '') + 'margin-top: 0 !important;' });
    }


    // contact
    $("form[name='contact_form']").on("submit", function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        data.push({ name: "action", value: "bpmprojectformcontact" });
        data.push({ name: "nonce_in", value: bpm_project_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        data.map(function(x) {
            return (post[x.name] = x.value);
        });

        $.ajax({
            url: bpm_project_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_project_data.errorStandard;
                    }

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Kontaktanfrage',
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            0
                        ]);
                    }
                } else {
                    $form[0].reset();
                    $(".form-group-captcha", $form).addClass("d-none");
                    messageTxt = json.message || "";

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Kontaktanfrage',
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            1
                        ]);
                    }
                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_project_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    )

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            }
        });

        return false;
    });
})(jQuery);
